import { render, staticRenderFns } from "./box.vue?vue&type=template&id=5a871e6e&scoped=true"
import script from "./box.vue?vue&type=script&lang=js"
export * from "./box.vue?vue&type=script&lang=js"
import style0 from "./box.vue?vue&type=style&index=0&id=5a871e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a871e6e",
  null
  
)

export default component.exports